// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ab2fef79","228":"649ea4d1","299":"8fbb0c98","343":"d3be5890","529":"3bfa9ec7","660":"fb8184e8","690":"d4081459","764":"fadb0c9f","793":"5aa21b8d","949":"2acbb06a","978":"47aca2ed","982":"825800ab"}[chunkId] + ".chunk.js";
};